{
  "account.availability.day.fri": "Fri",
  "account.availability.day.mon": "Mon",
  "account.availability.day.sat": "Sat",
  "account.availability.day.sun": "Sun",
  "account.availability.day.thu": "Thu",
  "account.availability.day.tue": "Tue",
  "account.availability.day.wed": "Wed",
  "account.member.a11y.contrast": "High contrast",
  "account.member.a11y.contrastHint": "Quiet text becomes full-strength ink.",
  "account.member.a11y.fontSize": "Text size",
  "account.member.a11y.fontSizeHint": "Scales every text in the app.",
  "account.member.a11y.fontSizeLarge": "Text size: large",
  "account.member.a11y.fontSizeNormal": "Text size: normal",
  "account.member.a11y.fontSizeSmall": "Text size: small",
  "account.member.a11y.hint": "These choices apply on this device and stay on it.",
  "account.member.a11y.links": "Underline links",
  "account.member.a11y.linksHint": "Marks links with more than colour.",
  "account.member.a11y.motion": "Reduced motion",
  "account.member.a11y.motionHint": "Stops animations and transitions.",
  "account.member.a11y.reset": "Reset to defaults",
  "account.member.a11y.singleKeys": "Single-key shortcuts",
  "account.member.a11y.singleKeysHint": "Keys like / and ? run commands when you are not typing. Turn this off if you use speech or a switch device. Shortcuts with ⌘ or Ctrl stay on.",
  "account.member.a11y.title": "Accessibility",
  "account.member.access.active": "Full access (active)",
  "account.member.access.fullHint": "Currently has full edit access across the workspace.",
  "account.member.access.hint": "Inactive members keep read-only access. They can view the workspace but cannot make changes. They are hidden from active team rosters, calendars and channels.",
  "account.member.access.inactive": "Read-only (inactive)",
  "account.member.access.left": "Deactivated (left)",
  "account.member.access.readOnlyHint": "Currently read-only. Restore to give full edit access.",
  "account.member.access.restore": "Restore full access",
  "account.member.access.saving": "Saving…",
  "account.member.access.setReadOnly": "Set read-only",
  "account.member.access.title": "Member access",
  "account.member.action.cancel": "Cancel",
  "account.member.action.edit": "Edit",
  "account.member.action.message": "Message",
  "account.member.action.settings": "Settings",
  "account.member.action.viewProfile": "View profile",
  "account.member.availability.readOnly": "Read only",
  "account.member.availability.title": "Availability",
  "account.member.availability.toggle": "Click to toggle cells. Shift+Click to multi-select cells.",
  "account.member.availability.toggleAdmin": "Click to toggle cells. Shift+Click to multi-select cells. (admin)",
  "account.member.avatar.change": "Change",
  "account.member.avatar.upload": "Upload photo",
  "account.member.checklist.availability": "Availability configured",
  "account.member.checklist.done": "Done",
  "account.member.checklist.location": "Location & Timezone set",
  "account.member.checklist.pending": "Pending",
  "account.member.danger.deactivate": "Deactivate account",
  "account.member.danger.deactivateBtn": "Deactivate",
  "account.member.danger.deactivateConfirm": "Confirm deactivation?",
  "account.member.danger.deactivateHint": "Hides your profile and revokes access. Contact admin to reactivate.",
  "account.member.danger.hint": "These actions are irreversible. Please be sure before proceeding.",
  "account.member.danger.personalOrgUndeletable": "You cannot delete a personal organization. It belongs to your account.",
  "account.member.danger.signOut": "Sign out",
  "account.member.danger.signOutBtn": "Sign out",
  "account.member.danger.signOutConfirm": "Confirm sign out?",
  "account.member.danger.signOutHint": "End your current session.",
  "account.member.danger.title": "Danger zone",
  "account.member.documents.empty": "No documents yet",
  "account.member.documents.open": "Open",
  "account.member.documents.title": "Documents",
  "account.member.field.city": "City",
  "account.member.field.country": "Country",
  "account.member.field.fullName": "Full name",
  "account.member.field.github": "GitHub",
  "account.member.field.position": "Position",
  "account.member.field.role": "Role",
  "account.member.field.team": "Team",
  "account.member.field.tenure": "Tenure",
  "account.member.field.timezone": "Timezone",
  "account.member.field.username": "Username",
  "account.member.notifications.birthdays": "Birthday reminders",
  "account.member.notifications.digest": "Email digest",
  "account.member.notifications.digestAria": "Email digest frequency",
  "account.member.notifications.digestHint": "Summary of announcements and meetings.",
  "account.member.notifications.mentions": "Mentions",
  "account.member.notifications.mentionsAria": "Mention notifications",
  "account.member.notifications.mentionsHint": "How you receive mention notifications.",
  "account.member.notifications.sound": "Notification sound",
  "account.member.notifications.title": "Notifications",
  "account.member.permissionDenied.message": "You don't have permission to update team membership. Please contact your administrator.",
  "account.member.permissionDenied.title": "Permission denied",
  "account.member.placeholder.city": "City",
  "account.member.placeholder.github": "username",
  "account.member.placeholder.name": "Your name",
  "account.member.placeholder.newPassword": "New password",
  "account.member.placeholder.position": "e.g. Frontend Engineer",
  "account.member.role.admin": "Admin",
  "account.member.role.coOwner": "Co-owner",
  "account.member.role.editor": "Member",
  "account.member.role.guest": "Guest",
  "account.member.role.manager": "Manager",
  "account.member.role.member": "Member",
  "account.member.role.owner": "Owner",
  "account.member.role.superadmin": "Superadmin",
  "account.member.role.viewer": "Contributor",
  "account.member.security.backupCodes": "Backup codes",
  "account.member.security.password": "Password",
  "account.member.security.passwordHint": "Change your login password.",
  "account.member.security.title": "Security",
  "account.member.security.twoFa": "Two-factor auth",
  "account.member.security.twoFaHint": "TOTP authenticator support planned.",
  "account.member.security.update": "Update",
  "account.member.security.updateFailed": "Failed",
  "account.member.security.updated": "Updated!",
  "account.member.select.none": "None",
  "account.member.session.activeNow": "Active now",
  "account.member.session.browser": "Browser",
  "account.member.session.platform": "Platform",
  "account.member.session.status": "Status",
  "account.member.session.title": "Current session",
  "account.member.team.create": "+ Create team…",
  "account.member.team.newPrompt": "New team name",
  "account.member.team.save": "Save",
  "account.member.team.saving": "Saving…",
  "account.member.toggle.off": "Off",
  "account.member.toggle.on": "On",
  "account.member.upload.failed": "Avatar upload failed",
  "account.member.uploadUnavailable.message": "SDK does not expose uploadFile in this build.",
  "account.member.uploadUnavailable.title": "Upload unavailable",
  "account.my.title": "My profile",
  "account.page.userProfile.title": "Profile",
  "account.profile.eyebrow": "Account",
  "account.profile.section": "People",
  "account.profile.sections.access": "Member access",
  "account.profile.sections.accessibility": "Accessibility",
  "account.profile.sections.availability": "Availability",
  "account.profile.sections.checklist": "Checklist",
  "account.profile.sections.danger_zone": "Danger zone",
  "account.profile.sections.details": "Details",
  "account.profile.sections.documents": "Documents",
  "account.profile.sections.mail": "Mail",
  "account.profile.sections.notifications": "Notifications",
  "account.profile.sections.profile": "Profile",
  "account.profile.sections.security": "Security",
  "account.profile.sections.sessions": "Sessions",
  "account.profile.title": "Profile",
  "account.userProfile.activity.less": "Less",
  "account.userProfile.activity.more": "More",
  "account.userProfile.activity.title": "ACTIVITY · LAST YEAR",
  "account.userProfile.browseAll": "Browse all people →",
  "account.userProfile.edit": "Edit profile",
  "account.userProfile.editDone": "Done",
  "account.userProfile.empty.agents": "No public agents.",
  "account.userProfile.empty.followers": "No followers yet.",
  "account.userProfile.empty.following": "Not following anyone yet.",
  "account.userProfile.empty.integrations": "No public integrations.",
  "account.userProfile.empty.projects": "No public projects yet.",
  "account.userProfile.fallbackName": "Profile",
  "account.userProfile.follow": "Follow",
  "account.userProfile.following": "Following",
  "account.userProfile.placeholder.bio": "Tell people what you build…",
  "account.userProfile.placeholder.location": "Where are you?",
  "account.userProfile.placeholder.name": "Your name",
  "account.userProfile.saveFailed": "Save failed",
  "account.userProfile.saved": "Saved",
  "account.userProfile.saving": "Saving…",
  "account.userProfile.tab.agents": "Agents",
  "account.userProfile.tab.followers": "Followers",
  "account.userProfile.tab.following": "Following",
  "account.userProfile.tab.integrations": "Integrations",
  "account.userProfile.tab.projects": "Projects",
  "account.userProfile.you": "You",
  "account.member.availability.reset": "Reset",
  "account.member.availability.selectAll": "Select all",
  "account.userProfile.joined": "Joined {date}",
  "account.member.assistant.title": "Assistant",
  "account.member.assistant.answers": "Answers",
  "account.member.assistant.answersHint": "Where the assistant's answers appear. Page builds a board on the home.",
  "account.profile.sections.assistant": "Assistant",
  "account.profile.settingsTitle": "Settings",
  "account.member.notSet": "Not set",
  "account.member.documents.sizeKb": "{size} KB",
  "account.member.documents.signedOn": "Signed {date}"
}
